import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "btn_text" }




export default /*@__PURE__*/_defineComponent({
  __name: 'primaryButton',
  props: {
    icon: {
        type: String,
        default: () => ''
    },
    text: {
        type: String,
        default: () => ''
    },
    textColor: {
        type: String,
        default: () => '#fff'
    },
    bgColor: {
        type: String,
        default: () => '#ffffff14'
    },
},
  emits: ['onClick'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const handleOnClick = () => {
    emits('onClick')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "button_container",
    style: _normalizeStyle({ color: props.textColor, background: props.bgColor }),
    onClick: handleOnClick
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(props.text), 1)
  ], 4))
}
}

})